<template>
  <v-avatar
    :color="color"
    :size="size"
  >
    <v-img
      v-if="fileId"
      :src="$file.url(fileId)"
    />
    <v-icon
      v-else
      :color="iconColor"
      :icon="icon"
    />
  </v-avatar>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    fileId?: number | null
    icon?: string
    color?: string
    iconColor?: string
    size?: string | number
  }>(),
  {
    fileId: null,
    icon: 'mdi-account',
    color: 'primary',
    iconColor: 'white',
    size: 25,
  },
)
</script>

<style scoped lang="scss"></style>
